import AddUser from './AddUser.vue';
import EditUser from './EditUser.vue';
import DeleteUser from './DeleteUser.vue';

export default {
    AddUser,
    EditUser,
    DeleteUser
}